import Wysiwyg from '~/themes/base/components/utils/Wysiwyg'

export default {
  name: 'Wysiwyg',
  extends: Wysiwyg,
}
